module.exports = __webpack_public_path__ + "static/flags/CN-977dba3eda4fa65fd2cd34ce8ce85f87.gif";